"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMiddleware = createMiddleware;
exports["default"] = createClient;
exports.run = run;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _wapplr = _interopRequireDefault(require("wapplr"));
var _initPWA = _interopRequireDefault(require("./initPWA"));
function createClient(_x) {
  return _createClient.apply(this, arguments);
}
function _createClient() {
  _createClient = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(p) {
    var wapp;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          wapp = p.wapp || (0, _wapplr["default"])((0, _objectSpread2["default"])({}, p));
          _context2.next = 3;
          return (0, _initPWA["default"])((0, _objectSpread2["default"])({
            wapp: wapp
          }, p));
        case 3:
          return _context2.abrupt("return", _context2.sent);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createClient.apply(this, arguments);
}
function createMiddleware() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/function () {
    var _pwaMiddleware = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(req, res, next) {
      var wapp;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = req.wapp || p.wapp;
            if (_context.t0) {
              _context.next = 5;
              break;
            }
            _context.next = 4;
            return createClient(p).wapp;
          case 4:
            _context.t0 = _context.sent;
          case 5:
            wapp = _context.t0;
            _context.next = 8;
            return (0, _initPWA["default"])((0, _objectSpread2["default"])({
              wapp: wapp
            }, p));
          case 8:
            next();
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function pwaMiddleware(_x2, _x3, _x4) {
      return _pwaMiddleware.apply(this, arguments);
    }
    return pwaMiddleware;
  }();
}
var defaultConfig = {
  config: {
    globals: {
      DEV: typeof DEV !== "undefined" ? DEV : undefined,
      WAPP: typeof WAPP !== "undefined" ? WAPP : undefined,
      RUN: typeof RUN !== "undefined" ? RUN : undefined,
      TYPE: typeof TYPE !== "undefined" ? TYPE : undefined,
      ROOT: typeof ROOT !== "undefined" ? ROOT : "/",
      NAME: typeof NAME !== "undefined" ? NAME : undefined
    }
  }
};
function run() {
  return _run.apply(this, arguments);
}
function _run() {
  _run = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
    var _p$config;
    var p,
      _p$config2,
      pwa,
      wapp,
      globals,
      DEV,
      app,
      _args3 = arguments;
    return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          p = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : defaultConfig;
          if (p !== null && p !== void 0 && (_p$config = p.config) !== null && _p$config !== void 0 && _p$config.globals && !p.config.globals.RUN) {
            p.config.globals.RUN = ((_p$config2 = p.config) === null || _p$config2 === void 0 ? void 0 : _p$config2.globals.NAME) || "wapplr-pwa";
          }
          _context3.next = 4;
          return createClient(p);
        case 4:
          pwa = _context3.sent;
          wapp = pwa.wapp;
          globals = wapp.globals;
          DEV = globals.DEV;
          app = wapp.client.app;
          app.use(createMiddleware((0, _objectSpread2["default"])({
            wapp: wapp
          }, p)));
          wapp.client.listen();
          if (typeof DEV !== "undefined" && DEV && module.hot) {
            app.hot = module.hot;
            module.hot.accept();
          }
          return _context3.abrupt("return", wapp);
        case 13:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _run.apply(this, arguments);
}
if (typeof RUN !== "undefined" && RUN === "wapplr-pwa") {
  run();
}